import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, HelpCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export const Footer = () => {
  const { i18n } = useTranslation();
  const lang = i18n.language;

  const content = {
    ru: {
      company: 'Pure Atelier Riga',
      tagline: 'Кастомные ювелирные изделия и помолвочные кольца',
      navigation: 'Навигация',
      home: 'Главная',
      collection: 'Коллекция',
      about: 'О нас',
      order: 'Заказ',
      reviews: 'Отзывы',
      contacts: 'Контакты',
      faq: 'FAQ',
      contactUs: 'Связаться',
      rights: 'Все права защищены',
    },
    lv: {
      company: 'Pure Atelier Riga',
      tagline: 'Pielāgoti juvelierizstrādājumi un saderināšanās gredzeni',
      navigation: 'Navigācija',
      home: 'Sākums',
      collection: 'Kolekcija',
      about: 'Par mums',
      order: 'Pasūtījums',
      reviews: 'Atsauksmes',
      contacts: 'Kontakti',
      faq: 'BUJ',
      contactUs: 'Sazināties',
      rights: 'Visas tiesības aizsargātas',
    }
  };

  const t = content[lang] || content.ru;

  return (
    <footer className="bg-secondary border-t border-border mt-auto">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Бренд */}
          <div>
            <h3 className="font-heading text-2xl mb-2">{t.company}</h3>
            <p className="font-body text-sm text-muted-foreground mb-4">{t.tagline}</p>
          </div>

          {/* Навигация */}
          <div>
            <h4 className="font-body text-sm uppercase tracking-widest mb-4 text-accent">{t.navigation}</h4>
            <div className="grid grid-cols-2 gap-2">
              <Link to="/" className="font-body text-sm text-muted-foreground hover:text-foreground transition-colors">{t.home}</Link>
              <Link to="/gallery" className="font-body text-sm text-muted-foreground hover:text-foreground transition-colors">{t.collection}</Link>
              <Link to="/about" className="font-body text-sm text-muted-foreground hover:text-foreground transition-colors">{t.about}</Link>
              <Link to="/order" className="font-body text-sm text-muted-foreground hover:text-foreground transition-colors">{t.order}</Link>
              <Link to="/reviews" className="font-body text-sm text-muted-foreground hover:text-foreground transition-colors">{t.reviews}</Link>
              <Link to="/contacts" className="font-body text-sm text-muted-foreground hover:text-foreground transition-colors">{t.contacts}</Link>
              <Link to="/faq" className="font-body text-sm text-muted-foreground hover:text-foreground transition-colors flex items-center gap-1">
                <HelpCircle className="w-3 h-3" />
                {t.faq}
              </Link>
            </div>
          </div>

          {/* Контакты */}
          <div>
            <h4 className="font-body text-sm uppercase tracking-widest mb-4 text-accent">{t.contactUs}</h4>
            <div className="space-y-2">
              <a href="tel:+37128448991" className="flex items-center gap-2 font-body text-sm text-muted-foreground hover:text-foreground transition-colors">
                <Phone className="w-4 h-4" />
                +371 28448991
              </a>
              <a href="mailto:pure.atelier.riga@gmail.com" className="flex items-center gap-2 font-body text-sm text-muted-foreground hover:text-foreground transition-colors">
                <Mail className="w-4 h-4" />
                pure.atelier.riga@gmail.com
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-border mt-8 pt-8 text-center">
          <p className="font-body text-xs text-muted-foreground">
            © {new Date().getFullYear()} {t.company}. {t.rights}.
          </p>
        </div>
      </div>
    </footer>
  );
};
